import React, { useContext } from "react";
import classNames from "classnames";
import { withRouter } from "react-router-dom";

import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import Business from "@material-ui/icons/Business";
import HistoryIcon from "@material-ui/icons/History";
import Home from "@material-ui/icons/Home";
import LocalParking from "@material-ui/icons/LocalParking";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Dashboard from "@material-ui/icons/Dashboard";
import ExitToApp from "@material-ui/icons/ExitToApp";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import AuthService from "../../../services/auth.service";
import GlobalContext from "../../../state/GlobalContext";
import { constantsApp } from "../../../constants/constants.app";

import Item from "./ItemLayout";

const drawerWidth = 220;

function PrivateDrawerLayout({ open, toggleDrawer, history }) {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const { session } = useContext(GlobalContext);
  const { user } = session.state;
  let isAdmin = false;
  let isPartner = false;
  let isCommunity = false;
  let isWorker = false;
  if (user && user !== null) {
    isAdmin = user.role === "admin";
    isWorker = user.role === "worker";
    isPartner = user.role === "partner";
    isCommunity = user.role === "community";
  }
  return (
    <Drawer
      variant={matches ? "temporary" : "permanent"}
      open={open}
      anchor={matches ? "right" : "left"}
      onClose={() => toggleDrawer()}
      classes={{
        paper: classNames(
          classes.drawerPaper,
          !open && classes.miniDrawerPaper,
          open && classes.openDrawer
        )
      }}
    >
      <Grid
        container
        justify="flex-end"
        classes={{ container: classes.drawerHeadContainer }}
      >
        {matches && (
          <IconButton
            onClick={toggleDrawer}
            classes={{ root: classes.iconButton }}
          >
            {theme.direction === "rtl" ? <ChevronLeft /> : <ChevronRight />}
          </IconButton>
        )}
      </Grid>
      <List classes={{ root: classes.list }}>
        <Item
          label={constantsApp.layouts.navigation.drawer.HOME_LBL}
          open={open}
          to="/"
          toggleDrawer={toggleDrawer}
        >
          <Home />
        </Item>
        {isAdmin || isCommunity ? (
          <Item
            label={constantsApp.layouts.navigation.drawer.COMMUNITY_LBL}
            open={open}
            to={constantsApp.routes.COMMUNITY}
            toggleDrawer={toggleDrawer}
          >
            <Business />
          </Item>
        ) : null}
        {isCommunity ? (
          <Item
            label="Logs"
            open={open}
            to={constantsApp.routes.LOGS}
            toggleDrawer={toggleDrawer}
          >
            <HistoryIcon />
          </Item>
        ) : null}
        {isAdmin || isWorker ? (
          <Item
            label={constantsApp.layouts.navigation.drawer.WORKER_LBL}
            open={open}
            to={constantsApp.routes.WORKER}
            toggleDrawer={toggleDrawer}
          >
            <Business />
          </Item>
        ) : null}
        {isAdmin || isPartner ? (
          <Item
            label={constantsApp.layouts.navigation.drawer.PARTNER_LBL}
            open={open}
            to={constantsApp.routes.PARTNER}
            toggleDrawer={toggleDrawer}
          >
            <LocalParking />
          </Item>
        ) : null}
        {isAdmin && (
          <Item
            label={constantsApp.layouts.navigation.drawer.ADMIN_LBL}
            open={open}
            to={constantsApp.routes.ADMIN}
            toggleDrawer={toggleDrawer}
          >
            <Dashboard />
          </Item>
        )}
        <Item
          label={constantsApp.layouts.navigation.drawer.LOGOUT_LBL}
          open={open}
          toggleDrawer={toggleDrawer}
          handleClick={async () => {
            AuthService.logout().then(() => {
              session.dispatch({ type: "LOGOUT" });
              window.location.reload();
            });
          }}
          bottom
        >
          <ExitToApp />
        </Item>
      </List>
    </Drawer>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  drawerHeadContainer: {
    minHeight: 56,
    borderBottom: `1px solid ${theme.palette.grey[400]}`,
    [theme.breakpoints.up("sm")]: {
      minHeight: 64
    }
  },
  drawerPaper: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
    height: "100%",
    [theme.breakpoints.only("md")]: {
      backgroundColor: theme.palette.background.paper
    }
  },
  list: {
    padding: 0,
    display: "flex",
    flex: 1,
    flexDirection: "column"
  },
  miniDrawerPaper: {
    width: 60,
    [theme.breakpoints.up("lg")]: {
      width: drawerWidth
    },
    background: theme.palette.background.paper,
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  openDrawer: {
    zIndex: 1500
  }
}));

export default withRouter(PrivateDrawerLayout);
